import type { BaseCmsCinemaElement } from '@omnia/ui/src/lib'
import { CinemaService } from '@omnia/ui/src/lib'
import { getSelectedCinemaGroup } from '@/features/cinema-groups/utils/get-selected-cinema-group'
import type { PagesEnum } from './models/pages'

export class CineColombiaCinemaService extends CinemaService<BaseCmsCinemaElement, PagesEnum> {
    protected cinemasPage: keyof PagesEnum = 'Cinemas'
    protected cinemaElementProperties: Array<keyof BaseCmsCinemaElement> = ['vistaCinema']

    public getVistaCinemas() {
        const allVistaCinemas = new Map<string, BaseCmsCinemaElement>(super.getVistaCinemas())
        const selectedCinemaGroupCinemas = getSelectedCinemaGroup()?.cinemas?.map(c => c.nodeId) ?? []

        for (const siteId of allVistaCinemas.keys()) {
            const cinema = allVistaCinemas.get(siteId)
            if (!cinema || !selectedCinemaGroupCinemas.includes(cinema.nodeId)) {
                allVistaCinemas.delete(siteId)
            }
        }

        return allVistaCinemas
    }
}

export const cinemaService = new CineColombiaCinemaService()
